import { createRouter, createWebHistory } from 'vue-router'
import AdminGameResultView from "@/views/admin/AdminGameResultView.vue";
import AdminTeamView from "@/views/admin/AdminTeamView.vue";
import AdminGameView from "@/views/admin/AdminGameView.vue";
import AdminGroupView from "@/views/admin/AdminGroupView.vue";
import GameView from "@/views/user/GameView.vue";
import GroupView from "@/views/user/GroupView.vue";
import HomeView from "@/views/user/HomeView.vue";
import { useAuthStore } from "@/stores/auth.ts";
import AdminDashboardView from "@/views/admin/AdminDashboardView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/admin',
      name: 'admin.dashboard',
      component: AdminDashboardView,
      meta: { requiredModules: [] }
    }, {
      path: '/admin',
      name: 'admin.games.results',
      component: AdminGameResultView,
      meta: { requiredModules: ['GAME_RESULT'] }
    }, {
      path: '/admin/teams',
      name: 'admin.teams',
      component: AdminTeamView,
      meta: { requiredModules: ['GAME_PLAN'] }
    }, {
      path: '/admin/games',
      name: 'admin.games',
      component: AdminGameView,
      meta: { requiredModules: ['GAME_PLAN'] }
    }, {
      path: '/admin/groups',
      name: 'admin.groups',
      component: AdminGroupView,
      meta: { requiredModules: ['GAME_PLAN'] }
    }, {
      path: '/',
      name: 'home',
      component: HomeView
    }, {
      path: '/games',
      name: 'games',
      component: GameView
    }, {
      path: '/groups',
      name: 'groups',
      component: GroupView
    }, {
      path: '/display',
      name: 'display',
      component: () => import('@/views/display/DisplayView.vue')
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/admin/LoginView.vue')
    }, {
      path: '/no-access',
      name: 'no-access',
      component: () => import('@/views/admin/NoAccessView.vue')
    }
  ],
})

router.beforeEach((to, from) => {
  if (!to.meta.requiredModules || !Array.isArray(to.meta.requiredModules)) {
    return true;
  }

  const authStore = useAuthStore();

  if (!authStore.account) {
    return { name: 'login', query: { route: to.name } } as never;
  }

  const modules: string[] = authStore.account.modules
  const hasAccess = to.meta.requiredModules.every((module: string) => modules.includes(module));
  if (!hasAccess) {
    return { name: 'no-access', query: { route: to.name } } as never;
  }
  return true;
})

export default router
